export const COMMON_TIMEZONES = [
  'UTC',
  'Europe/Paris',
  'Europe/London',
  'Europe/Berlin',
  'Europe/Madrid',
  'America/New_York',
  'America/Montreal',
  'America/Toronto',
  'America/Chicago',
  'America/Los_Angeles',
  'America/Mexico_City',
  'America/Sao_Paulo',
  'Asia/Dubai',
  'Asia/Shanghai',
  'Asia/Singapore',
  'Asia/Tokyo',
  'Africa/Cairo',
  'Africa/Johannesburg',
  'Australia/Sydney',
  'Pacific/Auckland'
];

export const detectBrowserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch (error) {
    return 'UTC';
  }
};

export const getTimezoneOptions = () => {
  const detected = detectBrowserTimezone();
  let values = [...COMMON_TIMEZONES];

  if (typeof Intl.supportedValuesOf === 'function') {
    try {
      const supported = Intl.supportedValuesOf('timeZone');
      if (Array.isArray(supported) && supported.length > 0) {
        values = supported;
      }
    } catch (error) {
      // keep common list fallback
    }
  }

  if (!values.includes(detected)) {
    values = [detected, ...values];
  }

  return values.map((value) => ({
    value,
    label: value
  }));
};
